import { siteApiSlice } from "../../app/siteApiSlice";
import { DataTablesQueryModel, DataTablesViewModel } from "../../interfaces/dataTables";

export interface AlertViewModel {
	dT_RowId: string;
	message: string;
	expireDate: string;
	isRead: boolean;
}

export const alertsApiSlice = siteApiSlice
	.enhanceEndpoints({
		addTagTypes: ["MyAlerts"],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getMyAlerts: build.query<DataTablesViewModel<AlertViewModel>, DataTablesQueryModel>({
				query: (q) => {
					const { iDisplayStart, iDisplayLength } = q;
					return {
						url: `/Alerts/MyAlertsAjaxHandler`,
						params: { iDisplayStart, iDisplayLength },
					};
				},
				providesTags: ["MyAlerts"],
			}),
			hideAlert: build.mutation<boolean, number>({
				query: (id) => ({
					url: `/Alerts/MarkReadOnAlert`,
					params: { id },
					method: "GET",
				}),
				invalidatesTags: ["Alerts"],
			}),
			hideAlerts: build.mutation<boolean, number[]>({
				query: (ids) => {
					const args = `ids=${ids.join("&ids=")}`;
					return {
						url: `/Alerts/MarkReadOnAlerts?${args}`,
						method: "GET",
					};
				},
				invalidatesTags: ["Alerts"],
			}),
			hideAllAlerts: build.mutation<boolean, void>({
				query: () => ({
					url: `/Alerts/MarkReadOnAllAlerts`,
					method: "GET",
				}),
				invalidatesTags: ["Alerts"],
			}),
			restoreAlert: build.mutation<boolean, number>({
				query: (id) => ({
					url: `/Alerts/UnmarkReadOnAlert`,
					params: { id },
					method: "GET",
				}),
				invalidatesTags: ["Alerts"],
			}),
		}),
	});

export const {
	useGetMyAlertsQuery,
	useHideAlertMutation,
	useHideAlertsMutation,
	useHideAllAlertsMutation,
	useRestoreAlertMutation,
} = alertsApiSlice;
